import { useDispatch, useSelector } from "react-redux";
import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useToast
} from "@chakra-ui/react";
import { createOrder, toggleCreateOrderModal } from "../../actions/orderActions";
import PlaceOrderForm from "../forms/PlaceOrderForm";

const PlaceOrderModal = () => {
    const dispatch = useDispatch();
    const showModal = useSelector((state) => state.orderCreate.showCreateOrderModal);
    const loading = useSelector((state) => state.orderCreate.loading);
    const toast = useToast();
    const closeModal = () => { dispatch(toggleCreateOrderModal()) }
    
    const handleCreateOrder = (order) => {
        dispatch(createOrder({
            order,
            onSuccess: () => {
                toast({
                    title: "Orden Creada",
                    description: "Tu orden ha sido creada exitosamente. Por favor, revisa tu correo para ver más detalles.",
                    status: "success",
                    duration: null,
                    isClosable: true,
                    position: "top",
                });
            },
            onError: (errorDescription = "Ha ocurrido un error, por favor intenta más tarde.") => {
                toast({
                    title: "Error al crear la orden",
                    description: errorDescription,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                    position: "top"
                });
            }
        }))
    }


    if (!showModal) return null;

    return (
        <Modal isOpen={showModal} onClose={!loading && closeModal} size="xl">
            <ModalOverlay />
            <ModalContent overflowY="auto">
                <ModalHeader>Confirmar Orden</ModalHeader>
                <ModalCloseButton />
                <ModalBody> 
                    <PlaceOrderForm
                        loading={loading}
                        closeModal={closeModal}
                        handleCreateOrder={handleCreateOrder}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default PlaceOrderModal;